import styled from 'styled-components';
import './animations.css';

export const Circle = styled.div<{ circleSize: number }>`
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colorPalette.turquoise.accent2};
  width: ${(props) => props.circleSize}px;
  height: ${(props) => props.circleSize}px;
  position: absolute;
  animation: ${({ theme }) => (theme.colorPalette.isDarkMode ? 'pulseDark' : 'pulse')} 3s infinite linear;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  opacity: ${({ theme }) => (theme.colorPalette.isDarkMode ? 0.6 : 1)};
  svg {
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
  }
`;
